module.exports = __webpack_public_path__ + "img/TheMastersHammerAndChisel.226ee9d1.jpeg";